// Thumbnail click handler
function goToMainSlide(slideIndex, device) {
  // Debounce rapid clicks (prevent multiple calls within 100ms)
  const now = Date.now();
  if (now - lastClickTime < 100) {
    return;
  }
  lastClickTime = now;

  // Set flag to prevent main slider change events from overriding thumbnail state
  isThumbnailClick = true;
  window.lastThumbnailClickTime = now;

  let allSlidesMedia = document.querySelectorAll(
    ".custom-swipix-container-pdp-img--desktop .pix-slide"
  );
  if (device === "mobile") {
    if (window.newPDPimgSwipix) {
      window.newPDPimgSwipix.slideTo(slideIndex);
    }
    allSlidesMedia = document.querySelectorAll(
      ".custom-swipix-container-pdp-img--mobile .pix-slide"
    );
  } else if (device === "desktop") {
    if (window.newPDPimgSwipixDesktop) {
      window.newPDPimgSwipixDesktop.slideTo(slideIndex);
    }
  }

  // Play restart video when active slide

  allSlidesMedia.forEach((slide) => {
    if (slide.classList.contains("swipix-slide-active")) {
      let video = slide.querySelector("video");

      if (video) {
        video.currentTime = 0;
        video.play();
      }
    }
  });

  // Update thumbnail active state (force update to bypass flag)
  updateThumbnailActive(slideIndex, device, true);

  // Reset flag after a longer delay to prevent conflicts
  setTimeout(() => {
    isThumbnailClick = false;
  }, 2000);
}

// Update thumbnail active state
function updateThumbnailActive(activeIndex, device, forceUpdate = false) {
  // If this is a thumbnail click, don't allow other updates to override it
  // But allow forced updates (from thumbnail clicks)
  if (isThumbnailClick && !forceUpdate) {
    return;
  }

  // Additional check: if we're trying to set to index 0 and it's not a forced update,
  // and we're not in a thumbnail click, be more careful
  if (activeIndex === 0 && !forceUpdate && !isThumbnailClick) {
    // Only allow this if it's been more than 3 seconds since last thumbnail click
    const now = Date.now();
    if (
      window.lastThumbnailClickTime &&
      now - window.lastThumbnailClickTime < 3000
    ) {
      return;
    }
  }

  const container =
    device === "mobile" ? ".pdp-thumbnail-mobile" : ".pdp-thumbnail-desktop";

  // Remove active class from all thumbnails
  document
    .querySelectorAll(`${container} .custom-thumbnail-slide`)
    .forEach((thumb) => {
      thumb.classList.remove("activefeat");
    });

  // Add active class to current thumbnail
  const activeThumbnail = document.querySelector(
    `${container} .custom-thumbnail-slide[data-slide-index="${activeIndex}"]`
  );
  if (activeThumbnail) {
    activeThumbnail.classList.add("activefeat");

    // Ensure active thumbnail is visible in viewport
    scrollThumbnailIntoView(activeThumbnail, device);
  }
}

// Scroll thumbnail into view to ensure it's visible
function scrollThumbnailIntoView(activeThumbnail, device) {
  const container =
    device === "mobile"
      ? ".mobile-thumbnail-container"
      : ".desktop-thumbnail-container";
  const containerEl = document.querySelector(container);

  if (!containerEl || !activeThumbnail) return;

  // Get the wrapper element (the one that actually scrolls)
  const wrapper = containerEl.querySelector(".custom-thumbnail-wrapper");
  if (!wrapper) return;

  const containerRect = containerEl.getBoundingClientRect();
  const thumbnailRect = activeThumbnail.getBoundingClientRect();

  // Check if thumbnail is outside the visible area
  const isOutOfViewLeft = thumbnailRect.left < containerRect.left;
  const isOutOfViewRight = thumbnailRect.right > containerRect.right;

  if (isOutOfViewLeft || isOutOfViewRight) {
    // Calculate how much to scroll to center the thumbnail
    const containerWidth = containerRect.width;
    const thumbnailLeft = activeThumbnail.offsetLeft;
    const thumbnailWidth = activeThumbnail.offsetWidth;

    // Center the thumbnail in the container
    const scrollPosition =
      thumbnailLeft - containerWidth / 2 + thumbnailWidth / 2;

    // Smooth scroll to the calculated position
    wrapper.scrollTo({
      left: Math.max(0, scrollPosition),
      behavior: "smooth",
    });
  }
}

// Make function globally accessible
window.goToMainSlide = goToMainSlide;

// Flag to prevent conflicts between thumbnail clicks and main slider changes
let isThumbnailClick = false;
let lastClickTime = 0;

// Add a small delay to ensure all other scripts have loaded
setTimeout(function () {
  // Initialize simple arrow navigation for mobile
  const mobileContainer = document.querySelector(".mobile-thumbnail-container");
  const mobileWrapper = mobileContainer?.querySelector(
    ".custom-thumbnail-wrapper"
  );
  const mobilePrev = document.querySelector(
    ".pdp-thumbnail-mobile .custom-left-arrow"
  );
  const mobileNext = document.querySelector(
    ".pdp-thumbnail-mobile .custom-right-arrow"
  );

  if (mobileContainer && mobileWrapper && mobilePrev && mobileNext) {
    mobilePrev.addEventListener("click", (e) => {
      e.preventDefault();

      // Find currently active thumbnail in the correct container
      const activeThumbnail = document.querySelector(
        "#mobile-thumbnail-container .custom-thumbnail-slide.activefeat"
      );
      if (activeThumbnail) {
        // Find previous thumbnail
        const prevThumbnail = activeThumbnail.previousElementSibling;
        if (
          prevThumbnail &&
          prevThumbnail.classList.contains("custom-thumbnail-slide")
        ) {
          // Click on previous thumbnail
          prevThumbnail.click();
        } else {
          // If no previous thumbnail, go to last thumbnail
          const allThumbnails = document.querySelectorAll(
            "#mobile-thumbnail-container .custom-thumbnail-slide"
          );
          if (allThumbnails.length > 0) {
            allThumbnails[allThumbnails.length - 1].click();
          }
        }
      }
    });

    mobileNext.addEventListener("click", (e) => {
      e.preventDefault();

      // Find currently active thumbnail in the correct container
      const activeThumbnail = document.querySelector(
        "#mobile-thumbnail-container .custom-thumbnail-slide.activefeat"
      );

      if (activeThumbnail) {
        // Find next thumbnail
        const nextThumbnail = activeThumbnail.nextElementSibling;

        if (
          nextThumbnail &&
          nextThumbnail.classList.contains("custom-thumbnail-slide")
        ) {
          // Click on next thumbnail
          nextThumbnail.click();
        } else {
          // If no next thumbnail, go to first thumbnail
          const firstThumbnail = document.querySelector(
            "#mobile-thumbnail-container .custom-thumbnail-slide"
          );
          if (firstThumbnail) {
            firstThumbnail.click();
          }
        }
      }
    });
  }

  // Initialize simple arrow navigation for desktop
  const desktopContainer = document.querySelector(
    ".desktop-thumbnail-container"
  );
  const desktopWrapper = desktopContainer?.querySelector(
    ".custom-thumbnail-wrapper"
  );
  const desktopPrev = document.querySelector(
    ".pdp-thumbnail-desktop .custom-left-arrow"
  );
  const desktopNext = document.querySelector(
    ".pdp-thumbnail-desktop .custom-right-arrow"
  );

  if (desktopContainer && desktopWrapper && desktopPrev && desktopNext) {
    desktopPrev.addEventListener("click", (e) => {
      e.preventDefault();

      // Find currently active thumbnail in the correct container
      const activeThumbnail = document.querySelector(
        "#desktop-thumbnail-container .custom-thumbnail-slide.activefeat"
      );
      if (activeThumbnail) {
        // Find previous thumbnail
        const prevThumbnail = activeThumbnail.previousElementSibling;
        if (
          prevThumbnail &&
          prevThumbnail.classList.contains("custom-thumbnail-slide")
        ) {
          // Click on previous thumbnail
          prevThumbnail.click();
        } else {
          // If no previous thumbnail, go to last thumbnail
          const allThumbnails = document.querySelectorAll(
            "#desktop-thumbnail-container .custom-thumbnail-slide"
          );
          if (allThumbnails.length > 0) {
            allThumbnails[allThumbnails.length - 1].click();
          }
        }
      }
    });

    desktopNext.addEventListener("click", (e) => {
      e.preventDefault();

      // Find currently active thumbnail in the correct container
      const activeThumbnail = document.querySelector(
        "#desktop-thumbnail-container .custom-thumbnail-slide.activefeat"
      );

      if (activeThumbnail) {
        // Find next thumbnail
        const nextThumbnail = activeThumbnail.nextElementSibling;

        if (
          nextThumbnail &&
          nextThumbnail.classList.contains("custom-thumbnail-slide")
        ) {
          // Click on next thumbnail
          nextThumbnail.click();
        } else {
          // If no next thumbnail, go to first thumbnail
          const firstThumbnail = document.querySelector(
            "#desktop-thumbnail-container .custom-thumbnail-slide"
          );
          if (firstThumbnail) {
            firstThumbnail.click();
          }
        }
      }
    });
  }

  // Fallback: Try to add click handlers to any arrow elements found
  const allArrows = document.querySelectorAll(
    ".custom-left-arrow, .custom-right-arrow"
  );

  allArrows.forEach((arrow) => {
    arrow.addEventListener("click", (e) => {
      e.preventDefault();

      // Find the closest thumbnail container
      const parentContainer = arrow.closest(".custom-featured-img-parent");
      if (parentContainer) {
        const isLeft = arrow.classList.contains("custom-left-arrow");
        const isMobile = parentContainer.classList.contains(
          "pdp-thumbnail-mobile"
        );
        const device = isMobile ? "mobile" : "desktop";
        const containerId = isMobile
          ? "#mobile-thumbnail-container"
          : "#desktop-thumbnail-container";

        // Find currently active thumbnail
        const activeThumbnail = document.querySelector(
          `${containerId} .custom-thumbnail-slide.activefeat`
        );
        if (activeThumbnail) {
          if (isLeft) {
            // Find previous thumbnail
            const prevThumbnail = activeThumbnail.previousElementSibling;
            if (
              prevThumbnail &&
              prevThumbnail.classList.contains("custom-thumbnail-slide")
            ) {
              prevThumbnail.click();
            } else {
              // If no previous thumbnail, go to last thumbnail
              const allThumbnails = document.querySelectorAll(
                `${containerId} .custom-thumbnail-slide`
              );
              if (allThumbnails.length > 0) {
                allThumbnails[allThumbnails.length - 1].click();
              }
            }
          } else {
            // Find next thumbnail
            const nextThumbnail = activeThumbnail.nextElementSibling;
            if (
              nextThumbnail &&
              nextThumbnail.classList.contains("custom-thumbnail-slide")
            ) {
              nextThumbnail.click();
            } else {
              // If no next thumbnail, go to first thumbnail
              const firstThumbnail = document.querySelector(
                `${containerId} .custom-thumbnail-slide`
              );
              if (firstThumbnail) {
                firstThumbnail.click();
              }
            }
          }
        }
      }
    });
  });
}, 1000);

// Add event listeners for main slider changes
document.addEventListener("swipix:slideChanged", function (e) {
  // Skip if this is a thumbnail click (to prevent conflicts)
  if (isThumbnailClick) {
    return;
  }

  // Add a small delay to prevent immediate updates
  setTimeout(() => {
    // Check if this is still a thumbnail click
    if (isThumbnailClick) {
      return;
    }

    // Check if it's our main sliders
    if (
      e.detail.carousel.config.container ===
      ".custom-swipix-container-pdp-img--mobile"
    ) {
      updateThumbnailActive(e.detail.currentIndex, "mobile");
    } else if (
      e.detail.carousel.config.container ===
      ".custom-swipix-container-pdp-img--desktop"
    ) {
      updateThumbnailActive(e.detail.currentIndex, "desktop");
    }
  }, 100);
});

// Listen for variant changes (this will be called by the existing variant change logic)
window.addEventListener("variantChanged", function (e) {
  // The existing getSlideIndexFromImageUrl function will handle the main slider change
  // We just need to update the thumbnail active state after a short delay
  setTimeout(function () {
    // Get current slide index from main sliders
    if (window.newPDPimgSwipix) {
      const mobileIndex = window.newPDPimgSwipix.getCurrentIndex
        ? window.newPDPimgSwipix.getCurrentIndex()
        : 0;
      updateThumbnailActive(mobileIndex, "mobile");
    }
    if (window.newPDPimgSwipixDesktop) {
      const desktopIndex = window.newPDPimgSwipixDesktop.getCurrentIndex
        ? window.newPDPimgSwipixDesktop.getCurrentIndex()
        : 0;
      updateThumbnailActive(desktopIndex, "desktop");
    }
  }, 200);
});

// Also listen for the existing variant change event that's already being used
document.addEventListener("change", function (e) {
  if (e.target.name === "id" && e.target.closest('form[action*="/cart/add"]')) {
    setTimeout(function () {
      // Get current slide index from main sliders
      if (window.newPDPimgSwipix) {
        const mobileIndex = window.newPDPimgSwipix.getCurrentIndex
          ? window.newPDPimgSwipix.getCurrentIndex()
          : 0;
        updateThumbnailActive(mobileIndex, "mobile");
      }
      if (window.newPDPimgSwipixDesktop) {
        const desktopIndex = window.newPDPimgSwipixDesktop.getCurrentIndex
          ? window.newPDPimgSwipixDesktop.getCurrentIndex()
          : 0;
        updateThumbnailActive(desktopIndex, "desktop");
      }
    }, 300);
  }
});

if (document.querySelectorAll(".npdp-radio-label-color").length > 0) {
  document.querySelectorAll(".npdp-radio-label-color").forEach((el) => {
    el.addEventListener("click", () => {
      // Check if current viewport width is "mobile"
      if (window.innerWidth <= 768) {
        window.scrollTo({
          top: 0,
          behavior: "smooth", // smooth scroll
        });
      }
    });
  });
}

document
  .querySelectorAll(".v2_main_sec_wrapper .rating-item")
  .forEach((item) => {
    item.addEventListener("click", () => {
      const target = document.querySelector(
        ".shopify-section.mattress-pdp-speed-review-parent"
      );
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });
